import React from 'react';

import { BrowserRouter as Routing, Route } from 'react-router-dom';

import App from '../containers/App';
import RedirectToPBL from './RedirectToPBL';

const Router = () =>
  <Routing>
    <div>
      <Route exact path="/" component={RedirectToPBL} />
      <Route exact strict path="/:license/:group" component={App} />
      <Route exact strict path="/:license" component={App} />
    </div>
  </Routing>;

export default Router;



// WEBPACK FOOTER //
// ./src/components/Router.js